import { Box, Stack } from "@mui/material";

export function SelectDateModel({ displayFullContent, resiliationDate, clientNumber, resiliationModelName }) {


  return (
    <CommonPart displayFullContent={displayFullContent} clientNumber={clientNumber} resiliationModelName={resiliationModelName}>
      <Box sx={{ fontSize: "14px", color: "#000000" }}>
        Je vous informe par la présente lettre ma volonté de résilier le contrat qui nous lie.
      </Box>
      <Box sx={{ fontSize: "14px", color: "#000000" }}>
        Je souhaite que cette résiliation prenne effet le {resiliationDate}, conformément aux dispositions légales et contractuelles en vigueur le cas échéant.
      </Box>
    </CommonPart>
  );
}

export function AsSoonAsPossibleModel({ displayFullContent, clientNumber, resiliationModelName }) {
  return (
    <CommonPart displayFullContent={displayFullContent} clientNumber={clientNumber} resiliationModelName={resiliationModelName}>
      <Box sx={{ fontSize: "14px", color: "#000000" }} >
        Je vous informe par la présente lettre ma volonté de résilier le contrat qui nous lie.
      </Box>
      <Box sx={{ fontSize: "14px", color: "#000000" }}>
        Je souhaite que cette résiliation prenne effet immédiatement à la réception de ce courrier, conformément aux dispositions légales et contractuelles en vigueur le cas échéant.
      </Box>
    </CommonPart>
  );
}

export function CustomModel({ formFields }) {
  return (
    <Stack direction="column" spacing="20px" sx={{ width: "100%" }}>
      <Box sx={{ fontSize: "14px", color: "#000000" }}>
        {" "}
        {formFields.messageObject}

      </Box>
      <Stack
        direction="column"
        spacing="20px"
        sx={{
          my: -2,
          color: "#000000",
          textShadow: "none",
          userSelect: "none",
          fontSize: "14px",
        }}
      >
        <Box dangerouslySetInnerHTML={{ __html: formFields.messageLetter }}></Box>
      </Stack>
    </Stack>
  );
}


function CommonPart({ displayFullContent, children, clientNumber, resiliationModelName }) {
  return (
    <Stack direction="column" spacing="20px">
      <Box color="#000000" sx={{ fontSize: "14px" }}>
        {" "}
        Objet : Résiliation de mon contrat
        <span style={{ fontWeight: "700" }}> {resiliationModelName} </span>
      </Box>
      <Box color="#000000" sx={{ fontSize: "14px" }}>
        {" "}
        Monsieur, Madame
      </Box>
      {children}
      <Stack
        direction="column"
        spacing="20px"
        sx={{
          my: -2,
          color: displayFullContent ? "#000000" : "transparent",
          textShadow: displayFullContent ? "none" : "0 0 12px #000",
          userSelect: "none"
        }}
      >
        <Box sx={{ fontSize: "14px" }}>
          Veuillez tenir compte de mes informations personnelles et client indiquées dans l'en-tête de la présente lettre.
        </Box>
        <Box sx={{ fontSize: "14px" }}>
          Je vous demande également de mettre un terme aux prélèvements automatiques effectués sur mon compte bancaire et de me confirmer cette action par écrit.
        </Box>
        <Box sx={{ fontSize: "14px" }}>
          Je vous saurais gré de bien vouloir me faire parvenir une confirmation écrite de la prise en compte de ma demande de résiliation ainsi qu'un état de clôture de compte, le cas échéant.
        </Box>
        <Box sx={{ fontSize: "14px" }}>
          Dans l'attente de votre retour, veuillez agréer, Madame, Monsieur, l'expression de mes salutations distinguées.
        </Box>
      </Stack>
    </Stack>
  );
}
